
import * as types from './mutations_types'
import {store} from '../../utils/';

export default {
	[types.update_areaOption](state, data) {
		state.areaOption = data;
	},

	[types.update_scoreItem](state, data) {
		state.scoreItem = data;
		store.set('scoreItem', state.scoreItem);
	},


  [types.update_subDomain](state, data) {
    state.subDomain = data;
    store.set('subDomain', state.subDomain);
  },
	

	
};